import React from "react";
import { NavLink } from "react-router-dom";

import iconUrl from "../images/url.svg";
import iconText from "../images/text.svg";
import iconVcard from "../images/vcard.svg";
import iconPhone from "../images/phone.svg";
import iconSms from "../images/sms.svg";
import iconWhatsapp from "../images/whatsapp.svg";
import iconUpi from "../images/upi.svg";

function QRLinks() {
  return (
    <header id="qrsection">
      <p>Select the type of QR code you want to generate:</p>
      <div className="grid button-grid">
        <NavLink to="/url-qr-code/" role="button">
          <img width="30" height="20" src={iconUrl} alt="url" />
          <span>URL</span>
        </NavLink>
        <NavLink to="/text-qr-code/" role="button">
          <img width="30" height="20" src={iconText} alt="url" />
          <span>Text</span>
        </NavLink>
        <NavLink to="/vcard-qr-code/" role="button">
          <img width="30" height="20" src={iconVcard} alt="url" />
          <span>vCard</span>
        </NavLink>
        <NavLink to="/phone-qr-code/" role="button">
          <img width="30" height="20" src={iconPhone} alt="url" />
          <span>Phone</span>
        </NavLink>
        <NavLink to="/sms-qr-code/" role="button">
          <img width="30" height="20" src={iconSms} alt="url" />
          <span>SMS</span>
        </NavLink>
        <NavLink to="/whatsapp-qr-code/" role="button">
          <img width="30" height="20" src={iconWhatsapp} alt="url" />
          <span>whatsApp</span>
        </NavLink>
        <NavLink to="/upi-qr-code/" role="button">
          <img width="30" height="20" src={iconUpi} alt="url" />
          <span>UPI</span>
        </NavLink>
      </div>
    </header>
  );
}

export default QRLinks;
